



















































import { todoListInstance } from '@/model/TodoListClass';
import { pubsub, UPDATE_TODO_EVENT } from '@/utils/pubsub';
import { generateLeaderTeams } from '@/utils/team';
import { todoTypeTool } from '@/utils/todo';

import { Component, Vue, Prop } from 'vue-property-decorator';

type ITodoInfo = ITodo.IResponse.ITodoInfo;
type ActiveKey = 'check' | 'change' | 'trans' | '';
type ICreateTodoParams = ITodo.IRequest.ICreateTodoParams;

type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;
interface IOperationModalConfig {
  todo: ITodoInfo;
  activeKey: ActiveKey;
}


@Component
export default class ReviewModal extends Vue {
  @Prop({required: true}) private userId!: string;
  private visible = false;
  private confirmLoading = false;
  private todo: ITodoInfo | null = null;
  private reviewNote = '';
  private changeValueNote = '';
  private newTodoValue = 0;
  private acceptorId = '';
  private activeKey: ActiveKey = '';
  private memberOptions: IUserDetailInfo[] = [];
  private filterOwnerOptions: IUserDetailInfo[] = [];
  get precision() {
    if (!this.todo) {
      return 2;
    }
    const todoType = todoTypeTool.getTodoTypeById(this.todo.typeId);
    if (todoType) {
      return todoType.formatType === 1 ? 0 : 2;
    } else {
      return 2;
    }
  }
  public showVisible(config: IOperationModalConfig) {
    this.visible = true;
    this.todo = config.todo;
    this.activeKey = config.activeKey;
    this.acceptorId = '';
    this.changeValueNote = '';
    this.reviewNote = '';
    this.newTodoValue = 0;
  }
  private created() {
    todoTypeTool.requestGetTodoTypes().catch((err) => {
      this.$message.warning(err);
    });
    generateLeaderTeams(this.userId).then((res) => {
      this.memberOptions = res;
      this.filterOwnerOptions = res.map((user) => user);
    }).catch((err) => err);
  }
  private onClose() {
    this.activeKey = '';
    this.visible = false;
    this.todo = null;
  }
  private reviewTodo() {
    if (!this.todo) {
      return;
    }
    this.confirmLoading = true;
    todoListInstance.requestUpdateTodoStatus(this.todo, 'Reviewed', this.reviewNote).then((res) => {
      this.$message.success(res);
      this.reviewNote = '';
      this.onClose();
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
  private changeTodoValue() {
    if (!this.todo) {
      return;
    }
    const note = this.changeValueNote.trim();
    if (note.trim().length < 1) {
      this.$message.warning(this.$t('todo.remarkTips').toString());
      return;
    }
    this.confirmLoading = true;
    todoListInstance.requestChangeItem<ICreateTodoParams>(this.todo, {
      ...this.todo,
      manDay: this.newTodoValue,
      comment: note,
    }).then((res) => {
      this.$message.success(res);
      pubsub.publish(UPDATE_TODO_EVENT, {...this.todo, manDay: this.newTodoValue, comment: this.changeValueNote});
      this.changeValueNote = '';
      this.newTodoValue = 0;
      this.onClose();
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
  private transAcceptor() {
    if (!this.todo) {
      return;
    }
    if (!this.acceptorId) {
      this.$message.warning(this.$t('todo.acceptorTips').toString());
      return;
    }
    this.confirmLoading = true;
    todoListInstance.requestTransAcceptor(this.todo, this.acceptorId).then((res) => {
      this.$message.success(res);
      this.acceptorId = '';
      this.onClose();
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
  private handleOk() {
    if (this.activeKey === 'check') {
      this.reviewTodo();
    } else if (this.activeKey === 'change') {
      this.changeTodoValue();
    } else if (this.activeKey === 'trans') {
      this.transAcceptor();
    }
  }
  private handleSearch(input: string) {
    this.filterOwnerOptions = this.memberOptions.filter((user) => {
      return user.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
    });
  }
}
